import { Subject } from 'rxjs';

// Discount floor / post-quote price cut gate (2026-10-17).
// The server answers 403 { discountGate: {...} } when a save needs a manager override; the entity thunks publish it here
// and the estimate wizard shows the dialog. The override (incl. approver password) travels ONLY through this variable
// for exactly one request, so it never lands in the redux store.
export const gateBlocked$ = new Subject<any>();

let pendingOverride: any = null;

export const setPendingOverride = (override: any) => {
  pendingOverride = override;
};

export const takePendingOverride = () => {
  const o = pendingOverride;
  pendingOverride = null;
  return o;
};
